// ── Design-system accent constants ───────────────────────────────────
// Flat, muted surfaces only — gradients are retired from the application.
// The legacy *_GRADIENT names are kept so the ~22 importers compile
// unchanged; each now resolves to a single flat CSS color value.

export const HERO_GRADIENT = '#1E3A5F';
export const ACCENT_GRADIENT_NAVY = '#1E3A5F';
export const ACCENT_GRADIENT_RED = '#6E1B1F';
export const ACCENT_GRADIENT_GREEN = '#1F5D3A';
export const ACCENT_GRADIENT_AMBER = '#8A5A11';
export const ACCENT_GRADIENT_ORANGE = '#8A5A11';

// The sanctioned banner stripe — render at 0.05 opacity.
export const CROSSHATCH_OVERLAY = 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,0.5) 10px, rgba(255,255,255,0.5) 11px)';

// ── Topic Accent Color Palette ───────────────────────────────────────
// 12 muted navy/gold/claret/moss colors; charts cycle through it.
// Assigned by topic display_order index for visual diversity across sections.
export const ACCENT_PALETTE = [
  '#1E3A5F', '#A88534', '#6E1B1F', '#1F5D3A', '#3F628D', '#8C6A21',
  '#842028', '#4E7A62', '#0E1F33', '#8A5A11', '#6B7180', '#2C4D75',
];
